import React, { useEffect, useState } from 'react';
import { Table, PageHeader, Select, DatePicker, Space } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { handleApiError, MyBreadcrumb } from 'utils';
import { emailSendLogListService } from 'services/email_send_log';
import moment from 'moment';

const { RangePicker } = DatePicker;
const { Option } = Select;

export default function EmailSendLogList() {
  const [isLoading, setIsLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [emailTypeFilter, setEmailTypeFilter] = useState(undefined);
  const [dateRange, setDateRange] = useState(undefined);

  const loadData = (params = {}) => {
    setIsLoading(true);
    const query = { ...params };
    if (emailTypeFilter) query.email_type = emailTypeFilter;
    if (dateRange && dateRange.length === 2) {
      query.from = dateRange[0].format('YYYY-MM-DD');
      query.to = dateRange[1].format('YYYY-MM-DD');
    }
    emailSendLogListService(query)
      .then((response) => {
        setIsLoading(false);
        setDataSource(response.data.items || []);
      })
      .catch((error) => {
        setIsLoading(false);
        handleApiError(error);
        setDataSource([]);
      });
  };

  useEffect(() => {
    loadData();
  }, [emailTypeFilter, dateRange, loadData]);

  const columns = [
    {
      title: 'Recipient email',
      dataIndex: 'recipient_email',
      key: 'recipient_email',
      ellipsis: true,
    },
    {
      title: 'Company / Branch',
      key: 'branch_network',
      render: (_, record) => {
        if (!record.branch_network) return '—';
        const bn = record.branch_network;
        const company = bn.company?.company_name || '';
        const branch = bn.branch?.branch_name || '';
        if (company && branch) return `${company} / ${branch}`;
        if (company) return company;
        if (branch) return branch;
        return bn.public_location_name || bn.reference_id || '—';
      },
    },
    {
      title: 'Client',
      key: 'client',
      render: (_, record) => (record.client ? record.client.client_name : '—'),
    },
    {
      title: 'Email type',
      dataIndex: 'email_type',
      key: 'email_type',
      render: (val) =>
        val === 'wifi_details' ? 'WiFi details' : 'Branch client print',
    },
    {
      title: 'Date & time',
      dataIndex: 'sent_at',
      key: 'sent_at',
      render: (val) => (val ? moment(val).format('YYYY-MM-DD HH:mm') : '—'),
    },
  ];

  return (
    <div>
      <MyBreadcrumb
        items={[
          { label: 'Home', path: '/' },
          { label: 'Monitoring & Logs', path: '/dashboardlog' },
          { label: 'Email log', path: '' },
        ]}
      />
      <PageHeader
        ghost={false}
        avatar={{ icon: <MailOutlined /> }}
        title="Email log"
        subTitle="Sent WiFi and branch client emails (Super Admin only)"
      >
        <Space style={{ marginBottom: 16 }} wrap>
          <Select
            placeholder="Email type"
            allowClear
            style={{ width: 180 }}
            value={emailTypeFilter}
            onChange={setEmailTypeFilter}
          >
            <Option value="wifi_details">WiFi details</Option>
            <Option value="branch_client_print">Branch client print</Option>
          </Select>
          <RangePicker value={dateRange} onChange={setDateRange} allowClear />
        </Space>
      </PageHeader>
      <Table
        dataSource={dataSource}
        columns={columns}
        loading={isLoading}
        rowKey="_id"
        pagination={{ pageSize: 20, showSizeChanger: true }}
      />
    </div>
  );
}
